import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: { name: 'dashboard' }
  },
  // {
  //   path: '/entry',
  //   name: 'entry',
  //   component: () =>
  //     import(/* webpackChunkName: "entry" */ '../views/Entry.vue'),
  // },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/gln',
    name: 'gln',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "gln" */ '../views/GLN.vue')
  },
  {
    path: '/product-list',
    name: 'productList',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "productList" */ '../views/ProductList.vue')
  },
  {
    // I5618: one page for the aanmeldformulier, packaging and marketing files. Replaces /import,
    // /import-packaging and /import-marketing; XXtract users only, like the packaging and
    // marketing pages were.
    path: '/upload',
    name: 'uploadFiles',
    meta: { requiresAuth: true, requiredPermissions: true },
    component: () => import(/* webpackChunkName: "uploadFiles" */ '../views/UploadFilesPage.vue')
  },
  // Old bookmarks of the three pages it replaced.
  { path: '/import', redirect: { name: 'uploadFiles' } },
  { path: '/import-packaging', redirect: { name: 'uploadFiles' } },
  { path: '/import-marketing', redirect: { name: 'uploadFiles' } },
  {
    path: '/product/:id',
    name: 'product-edit',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "ProductEdit" */ '../views/ProductEdit.vue')
  },
  {
    path: '/packaging',
    name: 'packaging',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "packaging" */ '../views/Packaging.vue')
  },
  {
    path: '/packaging/:id',
    name: 'packaging-edit',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "packaging" */ '../views/PackagingEdit.vue')
  },
  {
    path: '/confirmation',
    name: 'confirmationOrder',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "confirmationOrder" */ '../views/ConfirmationOrder.vue')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue')
  },
  {
    path: '/logistics/:id',
    name: 'logistics',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "logistics" */ '../views/Logistics.vue')
  },
  {
    path: '/logistics',
    name: 'logistics-multiple',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "logistics" */ '../views/Logistics.vue')
  },
  {
    path: '/retailers-list',
    name: 'retailersList',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "retailers" */ '../views/RetailersList.vue')
  },
  {
    path: '/marketing-information',
    name: 'marketingInformation',
    meta: { requiresAuth: true },
    props: true,
    component: () => import(/* webpackChunkName: "marketingInformation" */ '../views/MarketingInformation.vue')
  },
  {
    path: '/marketing-list',
    name: 'marketingList',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "marketingList" */ '../views/MarketingList.vue')
  },
  {
    path: '/order-history',
    name: 'orderHistory',
    meta: { requiresAuth: true },
    props: true,
    component: () => import(/* webpackChunkName: "orderHistory" */ '../views/OrderHistory.vue')
  },
  {
    path: '*',
    name: 'notFound',
    component: () => import(/* webpackChunkName: "404" */ '../views/NotFound.vue')
  },
  {
    path: '/version',
    name: 'version',
    component: () => import(/* webpackChunkName: "404" */ '../views/version.vue')
  },
  {
    path: '/create-shipment',
    name: 'create-shipment',
    component: () => import(/* webpackChunkName: "404" */ '../views/CreateShipment.vue')
  },
  {
    path: '/translation-tool',
    name: 'translationTool',
    meta: { requiresAuth: true, requiredPermissions: true },
    component: () => import(/* webpackChunkName: "404" */ '../views/TranslationTool.vue')
  },
  {
    path: '/packaging-list',
    name: 'PackagingList',
    meta: { requiresAuth: true, requiredPermissions: true },
    component: () => import(/* webpackChunkName: "404" */ '../views/PackagingList.vue')
  },
  {
    path: '/media-library',
    name: 'mediaLibrary',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "mediaLibrary" */ '../views/MediaLibrary.vue')
  },
  {
    path: '/bulk-edit',
    name: 'bulkEdit',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "bulkEdit" */ '../views/BulkEdit.vue')
  },

];

const router = new VueRouter({
  routes
});

// Every branch calls next() exactly once (I5618: the permission branch used to call it twice).
export function authGuard(to, from, next) {
  if (!to.matched.some((record) => record.meta.requiresAuth)) {
    return next();
  }
  // this route requires auth, check if logged in; if not, redirect to login page.
  const isLoggedIn = !!JSON.parse(localStorage.getItem('userId'));
  if (!isLoggedIn) {
    return next({ name: 'login' });
  }
  if (to.matched.some((record) => record.meta.requiredPermissions)) {
    const access = JSON.parse(localStorage.getItem('generalCompany')) == 'XXtract';
    if (!access) {
      return next('/');
    }
  }
  return next();
}

router.beforeEach(authGuard);

export default router;
